<template>
  <div class="mt-8 text-center">
    <p class="text-sm text-gray-500 flex items-center justify-center space-x-1">
      <ShieldCheckIcon class="w-4 h-4" />
      <span class="text-[11px] sm:text-base">
        Your data is protected with enterprise-grade security
      </span>
    </p>
  </div>
</template>

<script setup>
  import { ShieldCheckIcon } from "lucide-vue-next";
</script>
